var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('HomeParallax'),_c('EventBanners'),_c('HomeLive',{attrs:{"id":"live"}}),_c('HomeAbout'),_c('GetInTouch')],1)}
var staticRenderFns = []

export { render, staticRenderFns }